import styled from 'styled-components';
export const FormItem = styled.div`
  margin-bottom: 12px;

  button {
    margin-right: 12px;
  }
`;
export const Error = styled.div`
  color: red;
`;